import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";

import { FormShortAnswerBlock as Block } from "./FormShortAnswerBlock";
import { defaultData } from "./FormShortAnswerBlockDefaultData";
import { meta } from "./FormShortAnswerBlockMetaData";

export const FormShortAnswerBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-short-answer",
    size: 24,
  },
  meta,
};
